import Vue from 'vue'
import $bizConfig from '@/models/bizConfig.js';
import $web3js from '../web3.js';
import $utils from "@/lib/utils/index.js";

const contractInfo = require('./FilPledgeRedeem.json')

let web3 = $web3js.getWeb3();

let contractAddress = $bizConfig.filPledgeRedeemAddress;
let contractConst = {
    contract: web3 ? new web3.eth.Contract(contractInfo.abi, contractAddress) : '',
}

const getFilPledgeRedeemAddress = () => {
    return contractAddress;
}

const getFilPledgeRedeemContract = () => {
    return contractConst.contract;
}
const getFilDMinerAddressFromVendorAddress = (_DmexVendorAddress) => {
    return $bizConfig.ifilMiningContractAddressV4;
}
const getUserNFTWithdrawInfos = ([_vendorAddress, _pid,_user, _tokenId], options) => {
    const filDMinerAddress = getFilDMinerAddressFromVendorAddress(_vendorAddress);
    if (filDMinerAddress != "") {
        return $web3js.call(getFilPledgeRedeemContract().methods.getUserNFTWithdrawInfos, [filDMinerAddress,_pid, _user, _tokenId], options);
    } else {
        console.error("getUserNFTWithdrawInfos Not find filDMiner address by vendor address:" + _vendorAddress);
        return (0, 0);
    }
}


const checkUserTokenCanWithdraw = ([_vendorAddress, _user, _tokenId], options) => {
    const filDMinerAddress = getFilDMinerAddressFromVendorAddress(_vendorAddress);
    if (filDMinerAddress != "") {
        return $web3js.call(getFilPledgeRedeemContract().methods.checkUserTokenCanWithdraw, [filDMinerAddress, _user, _tokenId], options);
    } else {
        console.error("checkUserTokenCanWithdraw Not find filDMiner address by vendor address:" + _vendorAddress);
        return (false, 0);
    }
}

const userWithdrawPledge = ([_vendorAddress, _tokenId], options, callback) => {
    const filDMinerAddress = getFilDMinerAddressFromVendorAddress(_vendorAddress);
    if (filDMinerAddress != "") {
        return $web3js.send(getFilPledgeRedeemContract().methods.userWithdrawPledge, [filDMinerAddress,_tokenId], options, callback);
    } else {
        console.error("userWithdrawPledge Not find filDMiner address by vendor address:" + _vendorAddress);
        return (false, 0);
    }

}

const userWithdrawPledgeEstimateSend = async ([_vendorAddress, _tokenId], options) => {

    const filDMinerAddress = getFilDMinerAddressFromVendorAddress(_vendorAddress);
    let gasPromise = $web3js.estimateSend(getFilPledgeRedeemContract().methods.userWithdrawPledge, [filDMinerAddress, _tokenId], options);
    let gasPricePromise = $web3js.getGasPrice();

    let [e1, gas] = await $utils.awaitWrap(gasPromise);
    let [e2, gasPrice] = await $utils.awaitWrap(gasPricePromise);
    if (!!e1) {
        Vue.prototype.$toast(e1 && e1.message ? e1.message : e1);
        return null;
    }

    let fee = $web3js.fromWei(Vue.prototype.$numberUtils.mul(gasPrice, gas));
    return { gas, gasPrice, fee };
}

export default {
    getFilPledgeRedeemAddress,
    getFilPledgeRedeemContract,
    checkUserTokenCanWithdraw,
    userWithdrawPledge,
    userWithdrawPledgeEstimateSend,
    getUserNFTWithdrawInfos
}



// WEBPACK FOOTER //
// ./src/lib/contract/redeem/index.js